export default __webpack_public_path__ + "static/media/CollegeTonic.6e4ac604353cc4d0093d74498c0b0a56.webp";